// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subheading {
  font-size: 24px;
  font-weight: 400;
  margin-top: 10px;
}
.subheading-upper {
  font-size: 24px;
  font-weight: 400;
  margin-top: 10px;
  text-transform: uppercase !important;
}
.button-row-right {
  float: right;
}
.product-row {
  background-color: #2196f3;
  margin-top: 10px;
}
.header-tag-white {
  color: white !important;
  font-weight: 500;
  font-size: medium !important;
}
.white-tag-margin {
  margin-left: 20px !important;
}
.white-tag-margin-right {
  margin-left: 0px !important;
}
.green-button {
  background-color: #5ca900 !important;
  color: white;
}
.total-font {
  font-weight: 600;
  padding: 10px;
}
.footer-total {
  display: flex;
  justify-content: end;
  margin-bottom: 20px !important;
}
.totalvalue-font {
  margin-top: 3px;
}
.select-pharmacy {
  width: 100%;
  padding-bottom: 2px;
}
.purchase-label {
  padding: 10px 0px 10px 0px;
}
.purchase-label-textarea {
  margin-top: 3%;
}
.word-wrap {
  word-wrap: break-word;
}
.container-pharmacy {
  display: flex;
  padding: 1%;
}
.sharp-edge-button {
  border-radius: 0;
}
.blue-color {
  background-color: #3b5999 !important;
  color: aliceblue;
}
.secondary-color {
  background-color: #f19802 !important;
  color: aliceblue !important;
  border: none !important;
}
.secondary-color ::before {
  background-color: #f19802 !important;
  color: aliceblue !important;
  border: none !important;
}
.secondary-color:hover {
  background-color: #f19802 !important;
  color: aliceblue !important;
  border: none !important;
}
.container-wrapper {
  width: 100%;
  overflow-x: auto;
}
.button-alignment-pharmacy {
  margin-top: 5px;
  margin-left: 2px;
}
.view-heading {
  font-size: 20px !important;
  font-weight: 500;
}
.print-button {
  background-color: #5ca900;
  color: aliceblue;
}
.print-button:hover {
  background-color: #5ca900;
  color: aliceblue;
}
.view-name {
  font-size: 20px !important;
  font-weight: 500;
  color: #008e81;
  text-wrap: wrap;
}
.view-list-details {
  font-weight: 500;
}
.green-text {
  color: green;
}
.red-text {
  color: red;
}
.inline {
  display: inline;
}
.payment-heading {
  font-size: x-large !important;
  margin: 0px 10px 10px 0px;
}
@media screen and (min-width: 320px) and (max-width: 1200px) {
  .container-wrapper {
    overflow-x: scroll !important;
    display: flex;
  }
  .wide-content {
    width: 1000px;
  }
}
@media screen and (min-width: 320px) and (max-width: 576px) {
  .view-grid {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
}
@media (max-width: 567px) {
  .responsive-table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
}
div.scroll {
  width: 100%;
  overflow-x: auto;
}
.cancel-button {
  background-color: #ff6c60;
  color: white !important;
}
.cancel-button:hover {
  background-color: #ff6c60 !important;
  color: white !important;
}
.red-color {
  color: red;
}
.mb-15 {
  margin-bottom: 15px;
}
.cancel-btn {
  margin-top: 10px;
  margin-left: 12px;
}
.margin-row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.align-right {
  text-align: right;
}
.align-center {
  text-align: center;
}
.mt-10 {
  margin-top: 10px;
}
.mb-20 {
  margin-bottom: 20px;
}
.ml-10 {
  margin-left: 10px;
}
.p-2 {
  padding: 2px;
}
.cancel-sales {
  font-size: 20px;
  color: #808080;
  font-weight: 400;
}
.products {
  font-size: 20px;
  margin-bottom: 10px;
}
.p-12 {
  padding: 12px;
}
.fs-20 {
  font-size: 20px;
}
.no-wrap {
  white-space: nowrap;
}
.my-2 {
  margin-top: 2px;
  margin-bottom: 2px;
}
.delete-button {
  font-size: 20px !important;
  padding: 10px !important;
}
.add-button {
  margin-left: 10px;
  border: 2px solid black;
}
.invoice-content {
  margin-top: 5% !important;
}
.invoice-heading {
  color: #2f80bf !important;
  padding: 2% !important;
  font-size: 24px !important;
}
.invoice-heading-address {
  padding: 0% 0% 0% 2% !important;
  font-size: 16px !important;
}
.payment-invoice {
  font-weight: 500;
  text-align: center;
  font-size: larger;
}
.fw-5 {
  font-weight: 500;
}
@media print {
  .hide-on-print {
    display: none !important;
  }
}
.avatar-uploader {
  width: 120px;
  height: 120px;
  border: 2px dashed #d9d9d9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.ant-upload-text {
  margin-top: 8px;
}
.justify-center {
  display: flex;
  justify-content: center;
}
.product-selectbox {
  margin-top: 2%;
}
.custom-table-row {
  margin-bottom: 2px !important;
}
.btn-edits {
  margin-top: -20px !important;
}
.form-delete {
  margin-bottom: 90% !important;
}
.form-delete-stock {
  margin-bottom: 50% !important;
}
.item-button {
  margin-bottom: 30% !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/modules/pharmacy.less"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE;IACE,6BAA6B;IAC7B,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;EAChC;AACF;AACA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;AACF;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B","sourcesContent":[".subheading {\n  font-size: 24px;\n  font-weight: 400;\n  margin-top: 10px;\n}\n.subheading-upper {\n  font-size: 24px;\n  font-weight: 400;\n  margin-top: 10px;\n  text-transform: uppercase !important;\n}\n.button-row-right {\n  float: right;\n}\n.product-row {\n  background-color: #2196f3;\n  margin-top: 10px;\n}\n.header-tag-white {\n  color: white !important;\n  font-weight: 500;\n  font-size: medium !important;\n}\n.white-tag-margin {\n  margin-left: 20px !important;\n}\n.white-tag-margin-right {\n  margin-left: 0px !important;\n}\n.green-button {\n  background-color: #5ca900 !important;\n  color: white;\n}\n.total-font {\n  font-weight: 600;\n  padding: 10px;\n}\n.footer-total {\n  display: flex;\n  justify-content: end;\n  margin-bottom: 20px !important;\n}\n.totalvalue-font {\n  margin-top: 3px;\n}\n.select-pharmacy {\n  width: 100%;\n  padding-bottom: 2px;\n}\n.purchase-label {\n  padding: 10px 0px 10px 0px;\n}\n.purchase-label-textarea {\n  margin-top: 3%;\n}\n.word-wrap {\n  word-wrap: break-word;\n}\n.container-pharmacy {\n  display: flex;\n  padding: 1%;\n}\n.sharp-edge-button {\n  border-radius: 0;\n}\n.blue-color {\n  background-color: #3b5999 !important;\n  color: aliceblue;\n}\n.secondary-color {\n  background-color: #f19802 !important;\n  color: aliceblue !important;\n  border: none !important;\n}\n.secondary-color ::before {\n  background-color: #f19802 !important;\n  color: aliceblue !important;\n  border: none !important;\n}\n.secondary-color:hover {\n  background-color: #f19802 !important;\n  color: aliceblue !important;\n  border: none !important;\n}\n.container-wrapper {\n  width: 100%;\n  overflow-x: auto;\n}\n.button-alignment-pharmacy {\n  margin-top: 5px;\n  margin-left: 2px;\n}\n.view-heading {\n  font-size: 20px !important;\n  font-weight: 500;\n}\n.print-button {\n  background-color: #5ca900;\n  color: aliceblue;\n}\n.print-button:hover {\n  background-color: #5ca900;\n  color: aliceblue;\n}\n.view-name {\n  font-size: 20px !important;\n  font-weight: 500;\n  color: #008e81;\n  text-wrap: wrap;\n}\n.view-list-details {\n  font-weight: 500;\n}\n.green-text {\n  color: green;\n}\n.red-text {\n  color: red;\n}\n.inline {\n  display: inline;\n}\n.payment-heading {\n  font-size: x-large !important;\n  margin: 0px 10px 10px 0px;\n}\n@media screen and (min-width: 320px) and (max-width: 1200px) {\n  .container-wrapper {\n    overflow-x: scroll !important;\n    display: flex;\n  }\n  .wide-content {\n    width: 1000px;\n  }\n}\n@media screen and (min-width: 320px) and (max-width: 576px) {\n  .view-grid {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n  }\n}\n@media (max-width: 567px) {\n  .responsive-table {\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n}\ndiv.scroll {\n  width: 100%;\n  overflow-x: auto;\n}\n.cancel-button {\n  background-color: #ff6c60;\n  color: white !important;\n}\n.cancel-button:hover {\n  background-color: #ff6c60 !important;\n  color: white !important;\n}\n.red-color {\n  color: red;\n}\n.mb-15 {\n  margin-bottom: 15px;\n}\n.cancel-btn {\n  margin-top: 10px;\n  margin-left: 12px;\n}\n.margin-row {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n}\n.align-right {\n  text-align: right;\n}\n.align-center {\n  text-align: center;\n}\n.mt-10 {\n  margin-top: 10px;\n}\n.mb-20 {\n  margin-bottom: 20px;\n}\n.ml-10 {\n  margin-left: 10px;\n}\n.p-2 {\n  padding: 2px;\n}\n.cancel-sales {\n  font-size: 20px;\n  color: #808080;\n  font-weight: 400;\n}\n.products {\n  font-size: 20px;\n  margin-bottom: 10px;\n}\n.p-12 {\n  padding: 12px;\n}\n.fs-20 {\n  font-size: 20px;\n}\n.no-wrap {\n  white-space: nowrap;\n}\n.my-2 {\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n.delete-button {\n  font-size: 20px !important;\n  padding: 10px !important;\n}\n.add-button {\n  margin-left: 10px;\n  border: 2px solid black;\n}\n.invoice-content {\n  margin-top: 5% !important;\n}\n.invoice-heading {\n  color: #2f80bf !important;\n  padding: 2% !important;\n  font-size: 24px !important;\n}\n.invoice-heading-address {\n  padding: 0% 0% 0% 2% !important;\n  font-size: 16px !important;\n}\n.payment-invoice {\n  font-weight: 500;\n  text-align: center;\n  font-size: larger;\n}\n.fw-5 {\n  font-weight: 500;\n}\n@media print {\n  .hide-on-print {\n    display: none !important;\n  }\n}\n.avatar-uploader {\n  width: 120px;\n  height: 120px;\n  border: 2px dashed #d9d9d9;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n.ant-upload-text {\n  margin-top: 8px;\n}\n.justify-center {\n  display: flex;\n  justify-content: center;\n}\n.product-selectbox {\n  margin-top: 2%;\n}\n.custom-table-row {\n  margin-bottom: 2px !important;\n}\n.btn-edits {\n  margin-top: -20px !important;\n}\n.form-delete {\n  margin-bottom: 90% !important;\n}\n.form-delete-stock {\n  margin-bottom: 50% !important;\n}\n.item-button {\n  margin-bottom: 30% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
